import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import {
  activarUsuario,
  descargarUsuariosCsv,
  desactivarUsuario,
  getResumenUsuarios,
  getUsuarios,
  importarUsuariosMasivo,
  postUsuario,
  putUsuario,
  resetPasswordUsuario,
} from "../helpers/rutaUsuarios";
import "../css/usuarios-admin.css";
import ClavesMasivas from "./ClavesMasivas";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import ridersLogo from "../images/ridersmiami-logo.png";

const SEDES = [
  { value: "TUCUMAN", label: "Tucumán" },
  { value: "YERBA_BUENA", label: "Yerba Buena" },
  { value: "MIAMI", label: "Miami" },
];

const ROLES = [
  { value: "ADMIN_ROLE", label: "Administrador" },
  { value: "MANAGER_ROLE", label: "Manager Miami" },
  { value: "VENDEDOR_ROLE", label: "Vendedor" },
  { value: "LOGISTICA_ROLE", label: "Logística" },
  { value: "GERENCIA_ROLE", label: "Gerencia" },
  { value: "SUPERVISOR_ROLE", label: "Supervisor" },
  { value: "USER_ROLE", label: "Usuario" },
  { value: "USER_CAM", label: "Usuario CAM" },
  { value: "USER_PREV", label: "Usuario PREV" },
];

const FORM_INICIAL = {
  nombres: "",
  apellidos: "",
  dni: "",
  email: "",
  role: "VENDEDOR_ROLE",
  sede: "TUCUMAN",
  password: "",
};

const MOSTRAR_IMPORTACION_MIAMI = false;

const USUARIOS_MIAMI = [
  { nombres: "Ema", apellidos: "Serignese", email: "serigneseemanuel@gmail.com" },
  { nombres: "Andy", apellidos: "Kette", email: "andreskette01@gmail.com" },
  { nombres: "Vale", apellidos: "Feipe", email: "valentinafeipe@gmail.com" },
  { nombres: "Yami", apellidos: "Esber", email: "esberyamila@gmail.com" },
  { nombres: "Ramiro", apellidos: "Paz", email: "ramiropaz95@gmail.com" },
  { nombres: "Esteban", apellidos: "Capra", email: "capra1esteban@gmail.com" },
  { nombres: "Sergi", apellidos: "Alcaraz", email: "sergioalcaraz98@icloud.com" },
  { nombres: "Dair", apellidos: "Kette", email: "kette.dair@gmail.com" },
  { nombres: "Ignacio", apellidos: "Cocana", email: "ignacioandrescocana@gmail.com" },
  { nombres: "Chano", apellidos: "Lopez Salsench", email: "chanolopezsalsench@gmail.com" },
  { nombres: "Fefo", apellidos: "Collares", email: "fefocollares@gmail.com" },
  { nombres: "Marto", apellidos: "Moron", email: "martin.moron2001@gmail.com" },
  { nombres: "Juani", apellidos: "Cardozo", email: "juanignaciocardozo00@gmail.com" },
  { nombres: "Juan", apellidos: "Caluori", email: "caluorijuan8065@icloud.com" },
  { nombres: "Martin", apellidos: "Peralta", email: "martinsperalta8@gmail.com" },
  { nombres: "Manuel", apellidos: "Digdanian", email: "manudigdanian@gmail.com" },
  { nombres: "Uriel", apellidos: "Cuervo", email: "urielcuervo2098@icloud.com" },
  { nombres: "Sofia", apellidos: "Natalini", email: "natalinisofia2@gmail.com" },
  { nombres: "Gonzalo", apellidos: "Sozzo", email: "gsozzo96@gmail.com" },
  { nombres: "Franco", apellidos: "Dalle", email: "francodalle@hotmail.com" },
  { nombres: "Facundo", apellidos: "Sebastiano", email: "facusebastiano@gmail.com" },
  { nombres: "Francisco", apellidos: "Garcia Senia", email: "franciscogarciasenia@hotmail.com" },
  { nombres: "Agus", apellidos: "Cortes", email: "agus.cortes95@gmail.com" },
  { nombres: "Sofia", apellidos: "Lopez Salsench", email: "sofialopezsalsench@gmail.com" },
  { nombres: "Marcos", apellidos: "Mercorelli", email: "marcosmercorelli@gmail.com" },
  { nombres: "Matías", apellidos: "Oria", email: "matiasoria555@gmail.com" },
  { nombres: "Milagros", apellidos: "Luque", email: "milagros.luque1706@gmail.com" },
  { nombres: "Chiara", apellidos: "SIN APELLIDO", email: "chiaru99@gmail.com" },
  { nombres: "Roman", apellidos: "Durzo", email: "romaandurzo@gmail.com" },
  { nombres: "Lulu", apellidos: "Montenegro", email: "lucilamontenegro88@gmail.com" },
  { nombres: "Diego", apellidos: "Cervino", email: "diegocervino23@gmail.com" },
  { nombres: "Esber", apellidos: "SIN APELLIDO", email: "ezeesber10@gmail.com" },
  { nombres: "Felipe", apellidos: "SIN APELLIDO", email: "fcprojectllc@gmail.com" },
  { nombres: "Julio", apellidos: "Serrano", email: "cafeeserrano@gmail.com" },
  { nombres: "Agus", apellidos: "Avena", email: "avenaagus@icloud.com" },
  { nombres: "Tano", apellidos: "Cortinas", email: "cortinasr-c@hotmail.com" },
  { nombres: "Rodrigo", apellidos: "Paz", email: "rodrigopaz_9@hotmail.com" },
  { nombres: "Santiago", apellidos: "Lopez Pellicioli", email: "slopezpellicioli@gmail.com" },
  { nombres: "Martin", apellidos: "Leiva", email: "martinrrleiva1@gmail.com" },
  { nombres: "Leonidas", apellidos: "Rojas", email: "rojasleonidas47@gmail.com" },
  { nombres: "J_Dardo", apellidos: "Titanium", email: "dardotitaniummotors@gmail.com" },
  { nombres: "Roque", apellidos: "Saravia", email: "roque.a.saravia@gmail.com" },
  { nombres: "Sol", apellidos: "Retopaz", email: "solretopaz1@gmail.com" },
  { nombres: "Miguel", apellidos: "Gallardo", email: "m.gallardo8.mg@icloud.com" },
].map((usuario) => ({
  ...usuario,
  sede: "MIAMI",
  role: "VENDEDOR_ROLE",
}));

const etiquetaSede = (sede) =>
  SEDES.find((item) => item.value === sede)?.label || sede || "Tucumán";

const etiquetaRol = (role) => {
  if (role === "ROOT_ROLE") return "Root";
  return ROLES.find((item) => item.value === role)?.label || role;
};

const mensajeError = (respuesta) =>
  respuesta?.err?.message || respuesta?.message || "Ocurrió un error";

const cargarImagenPdf = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });

const sedeUsuarioPdf = (usuario = {}) => {
  const sede = String(
    usuario?.sede || "TUCUMAN"
  )
    .trim()
    .toUpperCase();

  if (sede === "MIAMI") return "MIAMI";
  if (sede === "YERBA_BUENA") return "YERBA_BUENA";

  return "TUCUMAN";
};

const usuarioLoginPdf = (usuario = {}) =>
  String(
    usuario?.usuario ||
      usuario?.username ||
      usuario?.email ||
      "-"
  ).trim();

const ordenarUsuariosPdf = (lista = []) =>
  [...lista].sort((a, b) => {
    const apellidoA = String(
      a?.apellidos || ""
    ).toLocaleLowerCase("es");

    const apellidoB = String(
      b?.apellidos || ""
    ).toLocaleLowerCase("es");

    const cmpApellido =
      apellidoA.localeCompare(
        apellidoB,
        "es"
      );

    if (cmpApellido !== 0) {
      return cmpApellido;
    }

    return String(
      a?.nombres || ""
    ).localeCompare(
      String(b?.nombres || ""),
      "es"
    );
  });

export default function UsuariosAdmin() {
  const [usuarios, setUsuarios] = useState([]);
  const [resumen, setResumen] = useState({
    TUCUMAN: 0,
    YERBA_BUENA: 0,
    MIAMI: 0,
    TOTAL: 0,
  });
  const [filtros, setFiltros] = useState({
    q: "",
    sede: "",
    role: "",
    incluirInactivos: false,
  });
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(FORM_INICIAL);
  const [passwordVisible, setPasswordVisible] = useState("");
  const [importandoMiami, setImportandoMiami] = useState(false);
  const [resultadoImportacion, setResultadoImportacion] = useState(null);

  const params = useMemo(
    () => ({
      q: filtros.q || undefined,
      sede: filtros.sede || undefined,
      role: filtros.role || undefined,
      incluirInactivos: filtros.incluirInactivos ? "true" : undefined,
    }),
    [filtros]
  );

  const cargarDatos = useCallback(async () => {
    setCargando(true);
    setError("");

    const [listaResp, resumenResp] = await Promise.all([
      getUsuarios(params),
      getResumenUsuarios(),
    ]);

    if (!listaResp?.ok) setError(mensajeError(listaResp));
    setUsuarios(listaResp?.usuarios || []);

    if (resumenResp?.ok) setResumen(resumenResp.resumen);
    setCargando(false);
  }, [params]);

  useEffect(() => {
    const timer = setTimeout(cargarDatos, 250);
    return () => clearTimeout(timer);
  }, [cargarDatos]);

  const abrirNuevo = () => {
    setEditando(null);
    setForm(FORM_INICIAL);
    setError("");
    setShowForm(true);
  };

  const abrirEditar = (usuario) => {
    setEditando(usuario);
    setForm({
      nombres: usuario.nombres || "",
      apellidos: usuario.apellidos || "",
      dni: usuario.dni || "",
      email: usuario.email || "",
      role: usuario.role || "USER_ROLE",
      sede: usuario.sede || "TUCUMAN",
      password: "",
    });
    setError("");
    setShowForm(true);
  };

  const cambiarForm = (campo, valor) => {
    setForm((anterior) => ({ ...anterior, [campo]: valor }));
  };

  const guardar = async (event) => {
    event.preventDefault();
    setGuardando(true);
    setError("");

    const payload = {
      nombres: form.nombres.trim(),
      apellidos: form.apellidos.trim(),
      dni: form.dni || undefined,
      email: form.email.trim().toLowerCase(),
      role: form.role,
      sede: form.sede,
    };

    if (!editando && form.password.trim()) payload.password = form.password.trim();

    const respuesta = editando
      ? await putUsuario(editando._id, payload)
      : await postUsuario(payload);

    setGuardando(false);

    if (!respuesta?.ok) {
      setError(mensajeError(respuesta));
      return;
    }

    setShowForm(false);
    if (!editando && respuesta.passwordTemporal) {
      setPasswordVisible(respuesta.passwordTemporal);
    }
    await cargarDatos();
  };

  const cambiarEstado = async (usuario) => {
    const accion = usuario.activo ? "desactivar" : "reactivar";
    if (!window.confirm(`¿Confirma ${accion} a ${usuario.nombres} ${usuario.apellidos}?`)) return;

    const respuesta = usuario.activo
      ? await desactivarUsuario(usuario._id)
      : await activarUsuario(usuario._id);

    if (!respuesta?.ok) {
      setError(mensajeError(respuesta));
      return;
    }

    await cargarDatos();
  };

  const resetearPassword = async (usuario) => {
    if (!window.confirm(`¿Generar una nueva contraseña provisoria para ${usuario.email}?`)) return;

    const respuesta = await resetPasswordUsuario(usuario._id);
    if (!respuesta?.ok) {
      setError(mensajeError(respuesta));
      return;
    }

    setPasswordVisible(respuesta.passwordTemporal || "");
  };

  const exportar = async () => {
    const respuesta = await descargarUsuariosCsv(params);
    if (!respuesta?.ok) setError(mensajeError(respuesta));
  };

  const exportarPdfUsuarios = async () => {
  try {
    setError("");

    /*
      El PDF es una foto completa del estado
      de usuarios al momento de generarlo.

      No respeta los filtros de pantalla:
      siempre incluye TODAS las sedes,
      activos e inactivos.
    */
    const respuesta = await getUsuarios({
      incluirInactivos: "true",
    });

    if (!respuesta?.ok) {
      setError(mensajeError(respuesta));
      return;
    }

    const lista = Array.isArray(
      respuesta?.usuarios
    )
      ? respuesta.usuarios
      : [];

    if (!lista.length) {
      setError(
        "No hay usuarios para generar el informe."
      );
      return;
    }

    const sedesOrdenadas = [
      {
        value: "TUCUMAN",
        label: "Tucumán",
      },
      {
        value: "YERBA_BUENA",
        label: "Yerba Buena",
      },
      {
        value: "MIAMI",
        label: "Miami",
      },
    ];

    const usuariosPorSede = {};

    sedesOrdenadas.forEach((sede) => {
      usuariosPorSede[sede.value] =
        ordenarUsuariosPdf(
          lista.filter(
            (usuario) =>
              sedeUsuarioPdf(usuario) ===
              sede.value
          )
        );
    });

    const totalUsuarios = lista.length;

    const totalActivos = lista.filter(
      (usuario) => usuario?.activo !== false
    ).length;

    const totalInactivos =
      totalUsuarios - totalActivos;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth =
      doc.internal.pageSize.getWidth();

    const pageHeight =
      doc.internal.pageSize.getHeight();

    const fechaAhora = new Date();

    const fechaTexto =
      fechaAhora.toLocaleDateString(
        "es-AR",
        {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }
      );

    const horaTexto =
      fechaAhora.toLocaleTimeString(
        "es-AR",
        {
          hour: "2-digit",
          minute: "2-digit",
        }
      );

    /* =====================================================
       ENCABEZADO
       ===================================================== */

    try {
      const logo =
        await cargarImagenPdf(
          ridersLogo
        );

      const anchoLogo = 32;

      const proporcion =
        (logo.naturalHeight ||
          logo.height ||
          1) /
        (logo.naturalWidth ||
          logo.width ||
          1);

      const altoLogo =
        anchoLogo * proporcion;

      doc.addImage(
        logo,
        "PNG",
        12,
        8,
        anchoLogo,
        Math.min(altoLogo, 20)
      );
    } catch (e) {
      console.warn(
        "No se pudo cargar el logo en el PDF:",
        e
      );
    }

    doc.setFont(
      "helvetica",
      "bold"
    );
    doc.setFontSize(20);

    doc.text(
      "LISTADO ACTUAL DE USUARIOS",
      pageWidth / 2,
      16,
      {
        align: "center",
      }
    );

    doc.setFont(
      "helvetica",
      "normal"
    );
    doc.setFontSize(10);

    doc.text(
      "Riders Miami - Administración de usuarios",
      pageWidth / 2,
      22,
      {
        align: "center",
      }
    );

    doc.setFontSize(8.5);

    doc.text(
      `Emitido: ${fechaTexto} - ${horaTexto} hs`,
      pageWidth - 12,
      15,
      {
        align: "right",
      }
    );

    doc.text(
      "Estado de usuarios por sede",
      pageWidth - 12,
      20,
      {
        align: "right",
      }
    );

    doc.setDrawColor(
      185,
      20,
      25
    );

    doc.setLineWidth(0.8);

    doc.line(
      12,
      29,
      pageWidth - 12,
      29
    );

    /* =====================================================
       RESUMEN GENERAL
       ===================================================== */

    doc.setFont(
      "helvetica",
      "bold"
    );
    doc.setFontSize(11);

    doc.text(
      "RESUMEN GENERAL",
      12,
      37
    );

    const resumenGeneral = [
      {
        titulo: "TOTAL USUARIOS",
        valor: totalUsuarios,
      },
      {
        titulo: "ACTIVOS",
        valor: totalActivos,
      },
      {
        titulo: "INACTIVOS",
        valor: totalInactivos,
      },
      ...sedesOrdenadas.map(
        (sede) => ({
          titulo: sede.label.toUpperCase(),
          valor:
            usuariosPorSede[
              sede.value
            ].length,
        })
      ),
    ];

    const margenX = 12;
    const gap = 3;

    const anchoCaja =
      (pageWidth -
        margenX * 2 -
        gap *
          (resumenGeneral.length -
            1)) /
      resumenGeneral.length;

    resumenGeneral.forEach(
      (item, index) => {
        const x =
          margenX +
          index *
            (anchoCaja + gap);

        doc.setFillColor(
          244,
          247,
          251
        );

        doc.setDrawColor(
          205,
          214,
          224
        );

        doc.roundedRect(
          x,
          41,
          anchoCaja,
          17,
          2,
          2,
          "FD"
        );

        doc.setFont(
          "helvetica",
          "normal"
        );

        doc.setTextColor(
          80,
          90,
          105
        );

        doc.setFontSize(7.5);

        doc.text(
          item.titulo,
          x + anchoCaja / 2,
          47,
          {
            align: "center",
          }
        );

        doc.setFont(
          "helvetica",
          "bold"
        );

        doc.setTextColor(
          15,
          35,
          65
        );

        doc.setFontSize(13);

        doc.text(
          String(item.valor),
          x + anchoCaja / 2,
          54,
          {
            align: "center",
          }
        );
      }
    );

    /* =====================================================
       RESUMEN POR SEDE
       ===================================================== */

    const resumenSedes =
      sedesOrdenadas.map(
        (sede) => {
          const usuariosSede =
            usuariosPorSede[
              sede.value
            ];

          const activos =
            usuariosSede.filter(
              (u) =>
                u?.activo !== false
            ).length;

          const inactivos =
            usuariosSede.length -
            activos;

          return [
            sede.label,
            usuariosSede.length,
            activos,
            inactivos,
          ];
        }
      );

    autoTable(doc, {
      startY: 64,

      margin: {
        left: 12,
        right: 12,
      },

      theme: "grid",

      head: [
        [
          "Sede",
          "Total",
          "Activos",
          "Inactivos",
        ],
      ],

      body: resumenSedes,

      styles: {
        fontSize: 9,
        cellPadding: 2.5,
        valign: "middle",
      },

      headStyles: {
        fillColor: [
          17,
          42,
          77,
        ],
        textColor: [
          255,
          255,
          255,
        ],
        fontStyle: "bold",
        halign: "center",
      },

      columnStyles: {
        0: {
          halign: "left",
          cellWidth: 55,
        },
        1: {
          halign: "center",
          cellWidth: 35,
        },
        2: {
          halign: "center",
          cellWidth: 35,
        },
        3: {
          halign: "center",
          cellWidth: 35,
        },
      },
    });

    /* =====================================================
       LISTADO DETALLADO POR SEDE
       ===================================================== */

    let y =
      (doc.lastAutoTable?.finalY ||
        90) + 9;

    for (
      const sede of sedesOrdenadas
    ) {
      const usuariosSede =
        usuariosPorSede[
          sede.value
        ];

      const activosSede =
        usuariosSede.filter(
          (u) =>
            u?.activo !== false
        ).length;

      const inactivosSede =
        usuariosSede.length -
        activosSede;

      /*
        Si no entra título + tabla,
        arrancamos nueva página.
      */
      if (
        y >
        pageHeight - 35
      ) {
        doc.addPage();
        y = 18;
      }

      doc.setFillColor(
        17,
        42,
        77
      );

      doc.roundedRect(
        12,
        y,
        pageWidth - 24,
        11,
        1.5,
        1.5,
        "F"
      );

      doc.setTextColor(
        255,
        255,
        255
      );

      doc.setFont(
        "helvetica",
        "bold"
      );

      doc.setFontSize(11);

      doc.text(
        `SEDE ${sede.label.toUpperCase()}`,
        16,
        y + 7
      );

      doc.setFontSize(8.5);

      doc.text(
        `Total: ${usuariosSede.length}   |   Activos: ${activosSede}   |   Inactivos: ${inactivosSede}`,
        pageWidth - 16,
        y + 7,
        {
          align: "right",
        }
      );

      doc.setTextColor(
        0,
        0,
        0
      );

      const filas =
        usuariosSede.map(
          (usuario, index) => [
            index + 1,

            String(
              usuario?.apellidos ||
                "-"
            ),

            String(
              usuario?.nombres ||
                "-"
            ),

            usuarioLoginPdf(
              usuario
            ),

            String(
              usuario?.email ||
                "-"
            ),

            etiquetaRol(
              usuario?.role
            ),

            usuario?.activo !== false
              ? "ACTIVO"
              : "INACTIVO",
          ]
        );
      if (!filas.length) {
        filas.push([
          "",
          "",
          "Sin usuarios registrados",
          "",
          "",
          "",
          "",
        ]);
      }

      autoTable(doc, {
        startY: y + 14,

        margin: {
          left: 12,
          right: 12,
          bottom: 17,
        },

        theme: "grid",

        head: [
          [
            "N°",
            "Apellido",
            "Nombre",
            "Usuario",
            "Email",
            "Rol",
            "Estado",
          ],
        ],

        body: filas,

        styles: {
          fontSize: 7.5,
          cellPadding: 2.2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fillColor: [
            185,
            20,
            25,
          ],

          textColor: [
            255,
            255,
            255,
          ],

          fontStyle: "bold",
          halign: "center",
        },

        alternateRowStyles: {
          fillColor: [
            247,
            249,
            252,
          ],
        },

        columnStyles: {
          0: {
            cellWidth: 10,
            halign: "center",
          },

          1: {
            cellWidth: 43,
          },

          2: {
            cellWidth: 36,
          },

          3: {
            cellWidth: 48,
          },

          4: {
            cellWidth: 66,
          },

          5: {
            cellWidth: 38,
            halign: "center",
          },

          6: {
            cellWidth: 28,
            halign: "center",
          },
        },

        didParseCell: (data) => {
          if (data.section !== "body") {
            return;
          }

          /*
            Sacamos el texto normal porque
            Rol y Estado se dibujan como píldoras.
          */
          if (
            data.column.index === 5 ||
            data.column.index === 6
          ) {
            data.cell.text = [];
          }
        },

        didDrawCell: (data) => {
          if (data.section !== "body") {
            return;
          }

          const dibujarPildora = ({
            texto,
            fondo,
            textoColor = [255, 255, 255],
          }) => {
            if (!texto) return;

            doc.setFont(
              "helvetica",
              "bold"
            );

            doc.setFontSize(6.8);

            const paddingX = 3;

            const anchoTexto =
              doc.getTextWidth(texto);

            const ancho =
              Math.min(
                data.cell.width - 3,
                anchoTexto +
                  paddingX * 2
              );

            const alto = 5.4;

            const x =
              data.cell.x +
              (data.cell.width -
                ancho) /
                2;

            const y =
              data.cell.y +
              (data.cell.height -
                alto) /
                2;

            doc.setFillColor(
              ...fondo
            );

            doc.roundedRect(
              x,
              y,
              ancho,
              alto,
              2.5,
              2.5,
              "F"
            );

            doc.setTextColor(
              ...textoColor
            );

            doc.text(
              texto,
              x + ancho / 2,
              y + 3.7,
              {
                align: "center",
              }
            );

            doc.setTextColor(
              0,
              0,
              0
            );
          };

          /* ---------------- ROL ---------------- */

          if (data.column.index === 5) {
            const rol = String(
              data.cell.raw || ""
            ).trim();

            if (rol === "Vendedor") {
              dibujarPildora({
                texto: rol,
                fondo: [30, 105, 210],
              });

              return;
            }

            if (rol === "Manager Miami") {
              dibujarPildora({
                texto: rol,
                fondo: [116, 70, 180],
              });

              return;
            }

            if (rol === "Administrador") {
              dibujarPildora({
                texto: rol,
                fondo: [190, 35, 45],
              });

              return;
            }

            if (rol === "Root") {
              dibujarPildora({
                texto: rol,
                fondo: [45, 50, 60],
              });

              return;
            }

            dibujarPildora({
              texto: rol || "-",
              fondo: [105, 115, 125],
            });
          }

          /* ---------------- ESTADO ---------------- */

          if (data.column.index === 6) {
            const estado = String(
              data.cell.raw || ""
            ).toUpperCase();

            if (estado === "ACTIVO") {
              dibujarPildora({
                texto: "ACTIVO",
                fondo: [225, 245, 232],
                textoColor: [15, 125, 60],
              });

              return;
            }

            dibujarPildora({
              texto: "INACTIVO",
              fondo: [252, 229, 229],
              textoColor: [180, 35, 35],
            });
          }
        },

        didDrawPage: () => {
          /*
            El pie definitivo se agrega
            después a todas las páginas.
          */
        },
      });

      y =
        (doc.lastAutoTable
          ?.finalY || y) + 10;
    }

    /* =====================================================
       PIE DE PÁGINA
       ===================================================== */

    const cantidadPaginas =
      doc.internal.getNumberOfPages();

    for (
      let pagina = 1;
      pagina <= cantidadPaginas;
      pagina += 1
    ) {
      doc.setPage(pagina);

      doc.setDrawColor(
        210,
        215,
        220
      );

      doc.line(
        12,
        pageHeight - 12,
        pageWidth - 12,
        pageHeight - 12
      );

      doc.setFont(
        "helvetica",
        "normal"
      );

      doc.setFontSize(7.5);

      doc.setTextColor(
        100,
        105,
        115
      );

      doc.text(
        `Riders Miami - Listado de usuarios al ${fechaTexto}`,
        12,
        pageHeight - 7
      );

      doc.text(
        `Página ${pagina} de ${cantidadPaginas}`,
        pageWidth - 12,
        pageHeight - 7,
        {
          align: "right",
        }
      );
    }

    const fechaArchivo =
      fechaAhora
        .toISOString()
        .slice(0, 10);

    doc.save(
      `Riders_Miami_Usuarios_${fechaArchivo}.pdf`
    );
  } catch (errorPdf) {
    console.error(
      "Error generando PDF de usuarios:",
      errorPdf
    );

    setError(
      "No se pudo generar el PDF de usuarios."
    );
  }
};

  const copiarPassword = async () => {
    try {
      await navigator.clipboard.writeText(passwordVisible);
    } catch {
      // El valor permanece visible para copiarlo manualmente.
    }
  };

  const descargarCredencialesMiami = (credenciales = []) => {
  if (!credenciales.length) return;

  const escapar = (valor) => {
    let texto = String(valor ?? "");

    if (/^[=+\-@]/.test(texto)) {
      texto = `'${texto}`;
    }

    return `"${texto.replace(/"/g, '""')}"`;
  };

  const filas = [
    [
      "Nombres",
      "Apellidos",
      "Email",
      "Sede",
      "Rol",
      "Clave provisoria",
    ],
    ...credenciales.map((usuario) => [
      usuario.nombres,
      usuario.apellidos,
      usuario.email,
      usuario.sede,
      usuario.role,
      usuario.passwordTemporal,
    ]),
  ];

  const csv = filas
    .map((fila) => fila.map(escapar).join(";"))
    .join("\r\n");

  const blob = new Blob([`\uFEFF${csv}`], {
    type: "text/csv;charset=utf-8;",
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  const fecha = new Date().toISOString().slice(0, 10);

  link.href = url;
  link.setAttribute(
    "download",
    `credenciales-miami-${fecha}.csv`
  );

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};

const importarMiami = async () => {
  const confirmar = window.confirm(
    `Se crearán ${USUARIOS_MIAMI.length} usuarios de Miami como vendedores.\n\n¿Desea continuar?`
  );

  if (!confirmar) return;

  setImportandoMiami(true);
  setError("");
  setResultadoImportacion(null);

  const respuesta =
    await importarUsuariosMasivo(USUARIOS_MIAMI);

  setImportandoMiami(false);

  if (!respuesta?.ok) {
    setError(mensajeError(respuesta));

    if (respuesta?.rechazados?.length) {
      setResultadoImportacion({
        creados: [],
        rechazados: respuesta.rechazados,
      });
    }

    return;
  }

  const creados = respuesta.credenciales || [];
  const rechazados = respuesta.rechazados || [];

  descargarCredencialesMiami(creados);

  setResultadoImportacion({
    creados,
    rechazados,
  });

  setFiltros((actual) => ({
    ...actual,
    sede: "MIAMI",
  }));

  await cargarDatos();
};

  return (
    <Container fluid className="usuarios-page py-4 px-3 px-lg-4">
      <div className="usuarios-heading">
        <div>
          <div className="usuarios-eyebrow">Administración exclusiva</div>
          <h1>Usuarios</h1>
          <p>Altas, sedes, permisos y contraseñas desde un solo lugar.</p>
        </div>
        <div className="usuarios-heading-actions">
            {MOSTRAR_IMPORTACION_MIAMI && (
              <Button
                variant="outline-success"
                onClick={importarMiami}
                disabled={importandoMiami}
              >
                {importandoMiami ? (
                  <>
                    <Spinner
                      animation="border"
                      size="sm"
                      className="mr-2"
                    />
                    Importando…
                  </>
                ) : (
                  `Importar Miami (${USUARIOS_MIAMI.length})`
                )}
              </Button>
            )}

          <Button
            variant="outline-primary"
            onClick={exportar}
          >
            Exportar CSV
          </Button>

          <Button
            variant="outline-danger"
            onClick={exportarPdfUsuarios}
          >
            PDF Usuarios
          </Button>
          <ClavesMasivas
            sede={filtros.sede}
            onComplete={cargarDatos}
          />
          <Button variant="primary" onClick={abrirNuevo}>
            + Nuevo usuario
          </Button>
        </div>
      </div>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError("")}>
          {error}
        </Alert>
      )}

      <Row className="g-3 mb-4">
        {SEDES.map((sede) => (
          <Col xs={12} md={4} key={sede.value}>
            <Card
              className={`usuarios-summary-card sede-${sede.value.toLowerCase()}`}
              onClick={() =>
                setFiltros((actual) => ({
                  ...actual,
                  sede: actual.sede === sede.value ? "" : sede.value,
                }))
              }
            >
              <Card.Body>
                <span>{sede.label}</span>
                <strong>{resumen[sede.value] || 0}</strong>
                <small>usuarios activos</small>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Card className="usuarios-panel">
        <Card.Body>
          <Row className="g-3 align-items-end mb-3">
            <Col xs={12} lg={4}>
              <Form.Label>Buscar</Form.Label>
              <Form.Control
                value={filtros.q}
                onChange={(e) => setFiltros((f) => ({ ...f, q: e.target.value }))}
                placeholder="Nombre, apellido o email"
              />
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <Form.Label>Sede</Form.Label>
              <Form.Control
                as="select"
                value={filtros.sede}
                onChange={(e) => setFiltros((f) => ({ ...f, sede: e.target.value }))}
              >
                <option value="">Todas</option>
                {SEDES.map((sede) => (
                  <option key={sede.value} value={sede.value}>{sede.label}</option>
                ))}
              </Form.Control>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <Form.Label>Rol</Form.Label>
              <Form.Control
                as="select"
                value={filtros.role}
                onChange={(e) => setFiltros((f) => ({ ...f, role: e.target.value }))}
              >
                <option value="">Todos</option>
                <option value="ROOT_ROLE">Root</option>
                {ROLES.map((role) => (
                  <option key={role.value} value={role.value}>{role.label}</option>
                ))}
              </Form.Control>
            </Col>
            <Col xs={12} lg={2}>
              <Form.Check
                type="switch"
                id="usuarios-inactivos"
                label="Incluir inactivos"
                checked={filtros.incluirInactivos}
                onChange={(e) =>
                  setFiltros((f) => ({ ...f, incluirInactivos: e.target.checked }))
                }
              />
            </Col>
          </Row>

          {cargando ? (
            <div className="usuarios-loading"><Spinner animation="border" /> Cargando usuarios…</div>
          ) : (
            <Table responsive hover className="usuarios-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th>Sede</th>
                  <th>Rol</th>
                  <th>Estado</th>
                  <th className="text-end">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {usuarios.map((usuario) => {
                  const esRoot = usuario.role === "ROOT_ROLE";
                  return (
                    <tr key={usuario._id} className={!usuario.activo ? "usuario-inactivo" : ""}>
                      <td>
                        <div className="usuario-name">{usuario.nombres} {usuario.apellidos}</div>
                        <div className="usuario-email">{usuario.email}</div>
                      </td>
                      <td><Badge variant="light" className="badge-sede">{etiquetaSede(usuario.sede)}</Badge></td>
                      <td>{etiquetaRol(usuario.role)}</td>
                      <td>
                        <Badge variant={usuario.activo ? "success" : "secondary"}>
                          {usuario.activo ? "Activo" : "Inactivo"}
                        </Badge>
                      </td>
                      <td>
                        <div className="usuarios-actions">
                          <Button size="sm" variant="outline-primary" onClick={() => abrirEditar(usuario)}>
                            Editar
                          </Button>
                          {!esRoot && (
                            <Button size="sm" variant="outline-warning" onClick={() => resetearPassword(usuario)}>
                              Nueva clave
                            </Button>
                          )}
                          {!esRoot && (
                            <Button
                              size="sm"
                              variant={usuario.activo ? "outline-danger" : "outline-success"}
                              onClick={() => cambiarEstado(usuario)}
                            >
                              {usuario.activo ? "Desactivar" : "Reactivar"}
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
                {!usuarios.length && (
                  <tr><td colSpan="5" className="text-center py-5 text-muted">No hay usuarios para los filtros seleccionados.</td></tr>
                )}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      <Modal
        show={showForm}
        onHide={() => !guardando && setShowForm(false)}
        centered
        size="lg"
        dialogClassName="usuarios-admin-modal"
      >
        <Form onSubmit={guardar}>
          <Modal.Header closeButton>
            <Modal.Title>{editando ? "Editar usuario" : "Nuevo usuario"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && <Alert variant="danger">{error}</Alert>}
            <Row className="g-3">
              <Col md={6}>
                <Form.Label>Nombres</Form.Label>
                <Form.Control required value={form.nombres} onChange={(e) => cambiarForm("nombres", e.target.value)} />
              </Col>
              <Col md={6}>
                <Form.Label>Apellidos</Form.Label>
                <Form.Control required value={form.apellidos} onChange={(e) => cambiarForm("apellidos", e.target.value)} />
              </Col>
              <Col md={5}>
                <Form.Label>DNI</Form.Label>
                <Form.Control type="number" value={form.dni} onChange={(e) => cambiarForm("dni", e.target.value)} />
              </Col>
              <Col md={7}>
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" required value={form.email} onChange={(e) => cambiarForm("email", e.target.value)} />
              </Col>
              <Col md={6}>
                <Form.Label>Sede</Form.Label>
                <Form.Control as="select" value={form.sede} onChange={(e) => cambiarForm("sede", e.target.value)}>
                  {SEDES.map((sede) => <option key={sede.value} value={sede.value}>{sede.label}</option>)}
                </Form.Control>
              </Col>
              <Col md={6}>
                <Form.Label>Rol</Form.Label>
                <Form.Control
                  as="select"
                  value={form.role}
                  disabled={editando?.role === "ROOT_ROLE"}
                  onChange={(e) => cambiarForm("role", e.target.value)}
                >
                  {editando?.role === "ROOT_ROLE" && <option value="ROOT_ROLE">Root</option>}
                  {ROLES.map((role) => <option key={role.value} value={role.value}>{role.label}</option>)}
                </Form.Control>
              </Col>
              {!editando && (
                <Col xs={12}>
                  <Form.Label>Contraseña inicial</Form.Label>
                  <Form.Control
                    type="text"
                    value={form.password}
                    onChange={(e) => cambiarForm("password", e.target.value)}
                    placeholder="Dejar vacía para generar una contraseña segura"
                    minLength={8}
                  />
                  <Form.Text className="text-muted">
                    Si queda vacía, el servidor generará una clave provisoria y la mostrará una sola vez.
                  </Form.Text>
                </Col>
              )}
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => setShowForm(false)} disabled={guardando}>Cancelar</Button>
            <Button type="submit" variant="primary" disabled={guardando}>
              {guardando ? "Guardando…" : "Guardar usuario"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={Boolean(passwordVisible)} onHide={() => setPasswordVisible("")} centered>
        <Modal.Header closeButton><Modal.Title>Contraseña provisoria</Modal.Title></Modal.Header>
        <Modal.Body>
          <Alert variant="warning">Copiala ahora. Por seguridad, no volverá a mostrarse.</Alert>
          <div className="password-temporal-box">
            <code>{passwordVisible}</code>
            <Button size="sm" onClick={copiarPassword}>Copiar</Button>
          </div>
        </Modal.Body>
        <Modal.Footer><Button onClick={() => setPasswordVisible("")}>Entendido</Button></Modal.Footer>
      </Modal>

      <Modal
        show={Boolean(resultadoImportacion)}
        onHide={() => setResultadoImportacion(null)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Importación de usuarios Miami</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!!resultadoImportacion?.creados?.length && (
            <Alert variant="success">
              Se crearon correctamente{" "}
              <strong>
                {resultadoImportacion.creados.length}
              </strong>{" "}
              usuarios.
              <br />
              El archivo CSV con las claves provisorias fue
              descargado automáticamente.
            </Alert>
          )}

          {!!resultadoImportacion?.rechazados?.length && (
            <>
              <Alert variant="warning">
                Se rechazaron{" "}
                <strong>
                  {resultadoImportacion.rechazados.length}
                </strong>{" "}
                registros.
              </Alert>

              <Table responsive size="sm">
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Motivo</th>
                  </tr>
                </thead>
                <tbody>
                  {resultadoImportacion.rechazados.map(
                    (item, index) => (
                      <tr key={`${item.email}-${index}`}>
                        <td>{item.email || `Fila ${item.fila}`}</td>
                        <td>{item.motivo}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setResultadoImportacion(null)}
          >
            Entendido
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
